import React from 'react';
import Login from "../../pages/Login/login"

export const MainCP = () => {
  return (
    <div className="container-fluid">
      <div className="row" style={{ marginTop: '40px' }}>
        <div className="col-12">
          <div className="d-flex justify-content-center">
            <Login/>
          </div>
        </div>
      </div>
    </div>
  )
}
